// extracted by mini-css-extract-plugin
export var bottom = "style-module--bottom--d8da3";
export var center = "style-module--center--50142";
export var containerHeadline = "style-module--containerHeadline--f3ad7";
export var corner = "style-module--corner--fd339";
export var fill = "style-module--fill--c199a";
export var flyingShapeContainer = "style-module--flyingShapeContainer--ce3ff";
export var fullSizeShapeContainer = "style-module--fullSizeShapeContainer--4d88b";
export var fullSizeShapeFill = "style-module--fullSizeShapeFill--89e4a";
export var fullSizeShapeLeft = "style-module--fullSizeShapeLeft--6a5f5";
export var fullSizeShapeRight = "style-module--fullSizeShapeRight--ed273";
export var mobileShape = "style-module--mobileShape--3f410";
export var originRight = "style-module--originRight--05a99";
export var shapeContainer = "style-module--shapeContainer--ddcf6";
export var shapeContent = "style-module--shapeContent--c5769";
export var top = "style-module--top--ec552";